import { render } from "./VaIconColor.vue?vue&type=template&id=4dcd0aa5"
import script from "./VaIconColor.vue?vue&type=script&lang=js"
export * from "./VaIconColor.vue?vue&type=script&lang=js"

import "./VaIconColor.vue?vue&type=style&index=0&id=4dcd0aa5&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__